export const POST_AGENTDETAILS = 'POST_AGENTDETAILS';
export const LIST_AGENTDETAILS = 'LIST_AGENTDETAILS';
export const GET_AGENTDETAILS = 'GET_AGENTDETAILS';
